import { Configuration, PopupRequest } from "@azure/msal-browser";

export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID!,
        authority: "https://login.microsoftonline.com/" + process.env.REACT_APP_AZURE_TENANT_ID + "/",
        redirectUri: process.env.REACT_APP_LOGIN_REDIRECT,
        postLogoutRedirectUri: process.env.REACT_APP_LOGOUT_REDIRECT
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["User.Read"]
};

export const dataRequest: PopupRequest = {
    //scopes: ["api://" + process.env.REACT_APP_AZURE_CLIENT_ID + "/Plant.Read"]
    scopes: ["api://" + process.env.REACT_APP_AZURE_CLIENT_ID + "/.default"]
}